import { Doughnut } from 'vue-chartjs'
import chart from '@/mixins/chart'
import Utils from '@/utils/charts'
import Colors from '@/utils/chart-options/colors'
import options from '@/utils/chart-options/doughnutsChart'

export default {
  extends: Doughnut,
  mixins: [chart],
  props: {
    options: {
      type: Object,
      default: () => options
    }
  },
  computed: {
    colors () {
      return {
        prepaid_minute: Colors[0](this),
        mail: Colors[1](this),
        service: Colors[2](this),
        product: Colors[3](this)
      }
    }
  },
  methods: {
    datasetToChartData (dataset) {
      const data = dataset.rows.filter(e => e[1])
      const dataByOfferType = data.reduce((result, item) => {
        result[item[2]] = result[item[2]] || []
        result[item[2]].push(({ label: Utils.label(item[0]), value: item[1] / 100 }))
        return result
      }, {})
      return {
        labels: Object.keys(dataByOfferType).map(key => this.$t(`charts.offertyperevenue.${key}`)),
        datasets: [
          {
            label: this.$t('charts.offertyperevenue.title'),
            data: Object.keys(dataByOfferType)
              .map(key => dataByOfferType[key]
                .reduce((sum, item) => (sum += item.value) && sum, 0)
              ),
            backgroundColor: Object.keys(dataByOfferType).map(e => this.colors[e]),
            hoverBackgroundColor: Object.keys(dataByOfferType).map(e => this.colors[e])
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/offerTypeRevenue.js